module.exports = require("./lib/_stream_duplex.js")



//////////////////
// WEBPACK FOOTER
// (webpack)/~/readable-stream/duplex.js
// module id = 424
// module chunks = 1 4 5 6 8 9 10 12 13 14 19 21 24 27 28 57